import React from 'react';
import './ProgressBonus.css';

import finishingLine from 'static/img/finishing-line.svg';

const ProgressBonus = (props) =>{

  const progressInPercent = props.progress.currentPoints * 100 / props.progress.pointsThreshold;
  const countProgress = (percent) => {
    const minWidth = 65;
    return `calc(${minWidth}px + ${percent}% - (${percent} / 100 * ${minWidth}px))`;
  }

  return (
    <div className="ProgressBonus">
      <p className="ProgressBonus-motivationText">{(props.period === 'current' ? 'Keep going! We only need' :'Next time we will do even better! We were')} <strong>{props.progress.pointsThreshold - props.progress.currentPoints} pts</strong> {(props.period === 'current' ? 'to reach the next' :'short of the next')} {props.progress.payment} PLN</p>
      <div className="ProgressBonus-bar">
        <div className="ProgressBonus-barProgress" style={{width: countProgress(progressInPercent)}}>
          <span className="ProgressBonus-barCurrentValue">{props.progress.currentPoints} pts</span>
        </div>
        <span className="ProgressBonus-barMaxValue">{props.progress.pointsThreshold} pts</span>
      </div>
      <div className="ProgressBonus-finishingLine">
        <img src={finishingLine} alt="" />
      </div>
    </div>
  )
}

export default ProgressBonus;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/ProgressBonus/ProgressBonus.js